import { render, staticRenderFns } from "./leaderDetail.vue?vue&type=template&id=049c3168&scoped=true"
import script from "./leaderDetail.vue?vue&type=script&lang=js"
export * from "./leaderDetail.vue?vue&type=script&lang=js"
import style0 from "./leaderDetail.vue?vue&type=style&index=0&id=049c3168&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049c3168",
  null
  
)

export default component.exports